import React from 'react';
import TooltipValidator from './TooltipValidator.jsx';

let it = 0;

export const Addons = {
  right: 1,
  left: 2
};

export default (field) => {
  const name = 'ig' + (field.input.name || it++);
  const id = (field.id || `${field.meta.form}_${name}`).replace('.', '_');
  
  let classes = field.className;
  if (field.meta.visited || !field.meta.pristine || field.meta.submitFailed) {
    if (field.meta.valid) {
      classes += ' is-valid';
    } else {
      classes += ' is-invalid';
    }
  }

  return (
    <div className="input-group">
      {(field.addons & Addons.left) > 0 && <span></span>}
      <TooltipValidator field={field} target={id} />
      <input 
        {...field.input} 
        type={field.type || 'text'}
        id={id} 
        placeholder={field.placeholder} 
        className={classes} />
      {(field.addons & Addons.right) > 0 && field.inputAddon}
    </div>
  );
};